import { useState } from "react";

const CORRECT_PASSWORD = "1234"; // ustaw swoje hasło

export default function AdminLogin({ onLogin }) {
  const [pass, setPass] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (pass === CORRECT_PASSWORD) {
      onLogin();  // ✔ przejście do /admin
    } else {
      alert("Nieprawidłowe hasło");
    }
  };

  return (
    <section className="section" style={{ maxWidth: 380, margin: "0 auto" }}>
      <h2 className="section-title">Panel administracyjny</h2>
      <p className="section-subtitle">
        Wprowadź hasło aby uzyskać dostęp.
      </p>

      <form onSubmit={handleSubmit} style={{ marginTop: 25 }}>
        <label>Hasło:</label>
        <input
          type="password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            marginTop: 10,
            marginBottom: 15
          }}
        />

        <button
          type="submit"
          className="btn-primary"
          style={{ width: "100%" }}
        >
          Zaloguj
        </button>
      </form>
    </section>
  );
}
